import React from 'react';
import './VRTherapy.css';
import vrImage from '../assets/vr2.jpeg';

const VRTherapy: React.FC = () => {
  const handleBookDemo = () => {
    window.open(
      'https://calendar.google.com/calendar/u/0/appointments/schedules/AcZssZ1rLxSwhVyDEIht-TrSvygW02E2G_NpddYYet6kX3V5Mf2rkdiNMtG9ZkFKW3Y7xJ0AYVSXKrCV',
      '_blank'
    );
  };

  return (
    <section className="vr-therapy">
      <div className="container">

        <div className="vr-text">
          <h2>
            Empowering You with a New Standard of VRET
          </h2>

          <div className="vr-features">
            <div className="vr-feature">
              <span className="vr-dot" />
              <p>Professional Learning Platform with Implementation Guides</p>
            </div>

            <div className="vr-feature">
              <span className="vr-dot" />
              <p>Comprehensive VRET Library with Realistic, High-Quality Graphics</p>
            </div>

            <div className="vr-feature">
              <span className="vr-dot" />
              <p>Specialist Dashboard for Managing and Supervising VRET Sessions</p>
            </div>

            <div className="vr-feature">
              <span className="vr-dot" />
              <p>Real-time tracking and supervision of therapy sessions from anywhere</p>
            </div>
          </div>

          <button className="demo-btn" onClick={handleBookDemo}>
            Book a Demo
          </button>
        </div>

        <div className="vr-image">
          <img src={vrImage} alt="VRET Experience" />
        </div>

      </div>
    </section>
  );
};

export default VRTherapy;
